
export type UnlikeProject200 = {
  code?: string;
  message?: string;
  success?: boolean;
};
